import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/WASHBANNER.jpg'
import WASHINGMACHINE from '../images/WASHINGMACHINE.png'
import { FaQuestionCircle } from "react-icons/fa";
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";
import WASHWORK1 from '../images/WASHWORK1.jpg';

import WASHWORK2 from "../images/WASHWORK2.jpg";
import WASHWORK3 from "../images/WASHWORK3.jpg";
import WASHWORK4 from "../images/WASHWORK4.jpeg";
import WASHWORK5 from "../images/WASHWORK5.jpg";
import WASHWORK6 from "../images/WASHWORK6.jpg";
import WASHWORK7 from "../images/WASHWORK7.jpg";

import { FaPhoneAlt } from 'react-icons/fa';

export default function WashingMachineService() {



  const faqs = [
    {
      question: "What makes your washing machine service low-cost?",
      answer: "Our service charges are lower than other service centers because we focus on efficiency and cost-saving measures. We pass the savings on to you."
    },
    {
      question: "What is your policy on repeat complaints?",
      answer: "If you experience the same issue within one month, we offer free services to resolve the problem at no additional cost."
    },
    {
      question: "Do you provide a warranty on spare parts?",
      answer: "Yes, we offer a 3 to 6-month warranty on all spare parts. The exact duration depends on the part and its manufacturer."
    },
    {
      question: "Can I see the spare parts before installation?",
      answer: "Absolutely. All spare parts are shown to the customer before installation to ensure transparency and trust."
    },
    {
      question: "How can I schedule a service?",
      answer: "You can call us anytime to schedule a service. We are available 24/7 for your convenience."
    },
    {
      question: "What types of washing machine issues do you handle?",
      answer: "We handle all types of washing machine issues including mechanical failures, electrical problems, and routine maintenance."
    },
    {
      question: "Are your technicians experienced?",
      answer: "Yes, our technicians are highly skilled and experienced in repairing and servicing washing machines of all brands and models."
    },
    {
      question: "Do you provide emergency repair services?",
      answer: "Yes, we offer emergency repair services to address urgent issues as quickly as possible."
    },
    {
      question: "How can I ensure my washing machine lasts longer?",
      answer: "Regular maintenance and prompt repair of issues can help extend the lifespan of your washing machine. We offer maintenance tips and services to help you."
    },
    {
      question: "What should I do if I have further questions?",
      answer: "If you have any additional questions, feel free to contact us anytime. We’re here to assist you with all your washing machine service needs."
    }
  ];


  const tips = [
    {
      title: "Regular Cleaning",
      content: "Clean the drum and detergent dispenser regularly to prevent buildup of detergent and mold."
    },
    {
      title: "Check Hoses",
      content: "Inspect hoses for leaks or damage to avoid water wastage and potential flooding."
    },
    {
      title: "Use the Right Detergent",
      content: "Use detergent specifically designed for washing machines to avoid excessive foam and residue."
    },
    {
      title: "Don't Overload",
      content: "Avoid overloading your washing machine to ensure effective cleaning and prevent damage."
    },
    {
      title: "Level the Machine",
      content: "Ensure the washing machine is level to avoid excessive noise and vibration during operation."
    },
    {
      title: "Use the Right Cycle",
      content: "Select the appropriate wash cycle based on the type of fabric to ensure effective cleaning and care."
    },
    {
      title: "Dry the Drum",
      content: "After each wash, leave the door open to dry the drum and prevent mold growth."
    },
    {
      title: "Check for Blockages",
      content: "Regularly check and clean the filter to prevent blockages and maintain optimal performance."
    },
    {
      title: "Avoid Fabric Softener Overuse",
      content: "Excessive use of fabric softener can cause residue buildup. Use it sparingly."
    },
    {
      title: "Call a Professional",
      content: "If problems persist, contact a certified technician for expert service and repair."
    }
  ];





  const accordionData = [
    {
      title: "Washing Machine Repairings",
      content: "We fix all types of washing machine issues with expert precision and quick turnaround time."
    },
    {
      title: "Washing Machine Maintenance",
      content: "Regular maintenance services to extend the life and performance of your machine."
    },
    {
      title: "Washing Machine Installation",
      content: "We provide secure and efficient installation for all new washing machines."
    },
    {
      title: "Washing Machine Troubleshooting",
      content: "We quickly identify and fix any technical or functional problems."
    },
    {
      title: "Washing Machine Parts Replacement",
      content: "We use genuine spare parts to replace faulty components like motors, drums, and PCBs."
    }
  ];



  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const toggleTip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const services = [
    { title: "Washing Machine Repairing", desc: "Quick Diagnosis", img: WASHWORK2 },
    { title: "Washing Machine Maintenance", desc: "Preventive Maintenance", img: WASHWORK3 },
    { title: "Washing Machine Installation", desc: "High-Quality Clean", img: WASHWORK4 },
    { title: "Washing Machine Service", desc: "Drum Repairing", img: WASHWORK5 },
    { title: "Parts Replacement", desc: "Board or Motor Swap", img: WASHWORK6 },
    { title: "Washing Machine Cleaning", desc: "Thorough Deep Clean", img: WASHWORK7 },
  ];


  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };




  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">Washing Machine Service Center</h1>
              <a href="tel:+919342851992" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your washing machine breaks down, don’t worry. Contact us, and we’ll handle the issue swiftly and professionally. We provide convenient, on-site washing machine repair services — just schedule a service call, and our experts will come to your home. Or, visit us directly and our skilled technicians will fix the problem promptly. We offer reliable and expert washing machine services for all brands and models, including both front-load and top-load machines. With over <strong>8+ years</strong> of experience in the appliance service industry, we are dedicated to delivering quality workmanship and complete customer satisfaction.
            </p>

            <img src={WASHINGMACHINE} alt='washing machine service' title='washing machine repair' className='img-fluid' />
          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <h3>Issue In Washing Machine</h3>
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>Washing Machine Not Starting</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>Water Not Draining Properly</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>Drum Not Spinning or Agitating</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>Excessive Noise or Vibration</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="500">
              <p>Water Leakage or Overflow</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="600">
              <p>Washing Cycle Not Completing</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="700">
              <p>Control Panel Not Responding</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="800">
              <p>Burning Smell or Overheating</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="900">
              <p>Door Won’t Open or Lock Malfunction</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="1000">
              <p>Regular Maintenance & Deep Cleaning</p>
            </div>

          </div>
        </div>
      </section>



      <section id="washing-machine-service" className="washing-service-section">
        <h2 className="section-title">What We Do for Washing Machine Service</h2>
        <div className="washing-service-grid">
          {services.map((service, index) => (
            <motion.div
              className="washing-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img src={service.img} alt={service.title} className="washing-img" />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="washing-accordion-section" className="accordion-wrapper">
        <div className="accordion-container">
          <div className="accordion-image">
            <img src={WASHWORK1} alt="Washing Machine Service" />
          </div>
          <div className="accordion-content">
            <h2>Washing Machine Service Details</h2>
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div
                  className={`accordion-title ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{item.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div
                  className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                >
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/*    
   <section id="desc" className="service-section">
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>Washing Machine Issues?</h2>
         <p>
           Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly. 
           We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
         </p>
         <a href="/washing-machine-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={WASHINGMACHINE} alt="Washing Machine Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>AC Not Cooling?</h2>
         <p>
           Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
         </p>
         <a href="/ac-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={AC} alt="AC Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>Fridge Not Working?</h2>
         <p>
           Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
         </p>
         <a href="/fridge-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={REF} alt="Fridge Service" />
       </div>
     </div>
   
     <div className="service-item" data-aos="fade-right">
       <div className="service-text">
         <h2>TV Not Turning On?</h2>
         <p>
           From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
         </p>
         <a href="/tv-service" className="service-btn">Fix Now</a>
       </div>
       <div className="service-image" data-aos="fade-left">
         <img src={TV} alt="TV Service" />
       </div>
     </div>
   </section>
   
   

   
    */}



      <section id="washing-tips-section" className="tips-wrapper">
        <div className="tips-container">
          <h2>Washing Machine Tips and Tricks</h2>
          <div className="tips-accordion">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-header" onClick={() => toggleTip(index)}>
                  <h3>{index + 1}. {tip.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className={`tip-body ${activeIndex === index ? "open" : ""}`}>
                  <p>{tip.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>
      <section id="washing-faq-section" className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-card" key={index}>
                <div className="faq-icon">
                  <FaQuestionCircle />
                </div>
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}
